import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import './TextToImage.css';
import ImageComponent from './components/image-component/ImageComponent';
import {
  toggleIsActive,
  changeTextProperty,
} from './../../redux/actions/entities/texts';

class TextToImage extends Component {
  constructor(props) {
    super(props);
    this.textTarget = '';
    this.imageRef = '';
  }

  setActive = (event) => {
    const targetId = event.target.getAttribute('data-id');

    if (targetId) {
      this.props.dispatch(toggleIsActive(parseInt(targetId, 10)));
    }
  }

  activeText = () => {
    const { texts } = this.props;
    return Object.values(texts).find(element => element.isActive);
  }

  handleStop = (event, data) => {
    const {
      x,
      y,
    } = data;

    const textFieldId = parseInt(event.target.getAttribute('data-id'), 10);
    const {
      marginLimit,
      pageRatio,
    } = this.props;

    const positions = {
      x: marginLimit - x === marginLimit ? marginLimit * pageRatio : (marginLimit + x) * pageRatio,
      y: marginLimit - y === marginLimit ? marginLimit * pageRatio : (marginLimit + y) * pageRatio,
    };


    // Save current position
    this.props.dispatch(changeTextProperty(textFieldId, 'positions', positions));
  };

  render() {
    const {
      id,
      images,
      texts,
      isActive,
      marginLimit,
      pageRatio,
      isSpineText,
      imageWidth,
    } = this.props;


    const { positions } = texts[id];

    const editorTextPosition = {
      x: (positions.x - (marginLimit * pageRatio)) / pageRatio,
      y: (positions.y - (marginLimit * pageRatio)) / pageRatio,
    };

    const wrapperStyle = {
      width: imageWidth / pageRatio,
    };


    const imageStyle = {
      height: 'initial',
    };

    return (
      <Draggable
        bounds="parent"
        handle=".text-wrapper"
        onStop={this.handleStop}
        enableUserSelectHack={false}
        position={editorTextPosition}
      >
        <div
          className={`text-wrapper ${isActive ? 'active' : ''}`}
          ref={(textTarget) => { this.textTarget = textTarget; }}
          onKeyPress={() => {}}
          onClick={(event) => { this.setActive(event); }}
          role="button"
          tabIndex="-4"
          data-id={id}
          style={!isSpineText ? wrapperStyle : ''}
        >
          { images !== undefined &&
            <ImageComponent
              image={images.thumbnail.relativeURl}
              pageRatio={pageRatio}
              imageRef={(imageRef) => { this.imageRef = imageRef; }}
              style={imageStyle}
            />
          }

        </div>
      </Draggable>
    );
  }
}

TextToImage.defaultProps = {
  id: 0,
  images: {
    thumbnail: '',
    full: '',
  },
  texts: {},
  marginLimit: 0,
  pageRatio: 1,
  isActive: false,
  isSpineText: false,
  imageWidth: 0,
};

TextToImage.propTypes = {
  id: PropTypes.number,
  images: PropTypes.object,
  texts: PropTypes.object,
  isActive: PropTypes.bool,
  pageRatio: PropTypes.number,
  marginLimit: PropTypes.number,
  isSpineText: PropTypes.bool,
  imageWidth: PropTypes.number,
};

export default connect(state => ({
  texts: state.entities.texts,
}))(TextToImage);




// WEBPACK FOOTER //
// ./src/components/text-to-image/TextToImage.jsx